import { schema } from 'normalizr'

export const modulo = new schema.Entity('modulo')

export default {
  namespaced: true,
  state: {
    list: {}
  },
  mutations: {
    setAll (state, payload) {
      state.list = Object.assign({}, payload)
    },
    tienePago (state, payload) {
      state.tienePago = payload
    }
  },
  actions: {
  },
  getters: {
    getAll (state) {
      return Object.keys(state.list).map(id => state.list[id])
        .sort((x, y) => x.orden - y.orden)
    },
    getAllByModulosOrdenId (state, getters) {
      return modulosOrdenId => getters.getAll.filter(x => x.modulosOrdenId === modulosOrdenId)
    },
    getById (state) {
      return id => state.list[id]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modulosOrdenes/modulos/store.js